<template>
  <div class="article">
    <div class="article__elements">
      <Cross class="mobile-hidden" img-width="10rem" bottom="7rem" left="43.8rem" color="orange" />
      <Cross class="mobile-hidden" img-width="4.2rem" top="30.7rem" left="8.2rem" color="orange" />
      <Snowflake2 class="mobile-hidden" img-width="6rem" bottom="4rem" left="16rem" color="orange" />
      <Snowflake2 class="mobile-hidden" img-width="4rem" top="21rem" left="67.5rem" color="orange" />
      <Snowflake2 class="mobile-hidden" img-width="8rem" top="24.5rem" right="11.6rem" color="orange" />
      <Snowflake3 class="mobile-hidden" img-width="5.5rem" bottom="25rem" right="8.8rem" color="orange" />
      <Gift3 class="mobile-hidden" img-width="7.5rem" bottom="18.2rem" left="5.8rem" />
      <Gift4 class="mobile-hidden" img-width="11.3rem" bottom="9.4rem" right="16rem" />
      <Tree2 class="mobile-hidden" img-width="8rem" bottom="15.2rem" left="60rem" />
      <Star2 class="mobile-hidden" img-width="4.5rem" top="21.5rem" left="26rem" />
    </div>

    <div class="article__img article__img--7">
      <img class="mobile-hidden" src="@/assets/img/article7.png" alt="">
      <img class="mobile-visible" src="@/assets/img/article7-mob.png" alt="">
    </div>
    <div class="article__content">
      <h2 class="article__title">
        {{ 'Росмолодежь и #МЫВМЕСТЕ' | typograf }}
      </h2>
      <p class="article__subtitle">
        {{ 'Накануне новогодних праздников Росмолодежь и партнеры проекта #МЫВМЕСТЕ запустили ряд волонтерских акций для детей и взрослых, оказавшихся в сложной жизненной ситуации.' | typograf }}
      </p>
      <p class="article__text">
        {{ 'Принять участие может любой желающий в каждом российском регионе. Подробнее со всеми акциями можно ознакомиться в спецпроекте «Ленты.ру»' | typograf }}
      </p>
      <div class="article__button-box">
        <a href="https://lenta.ru/news/2021/12/21/akzii/" target="_blank">
          <button @click="gtmSend" class="button button--orange">Читать специальный материал</button>
        </a>
      </div>

      <ArticleFooter />
    </div>
  </div>
</template>

<script>
  import './article.scss'
  import Cross from "../Elements/Cross";
  import Snowflake2 from "../Elements/Snowflake2";
  import ArticleFooter from "../ArticleFooter/ArticleFooter";
  import Gift3 from "../Elements/Gift3";
  import Tree2 from "../Elements/Tree2";
  import Snowflake3 from "../Elements/Snowflake3";
  import Gift4 from "../Elements/Gift4";
  import Star2 from "../Elements/Star2";
  export default {
    name: "Article7",
    components: {Star2, Gift4, Snowflake3, Tree2, Gift3, ArticleFooter, Snowflake2, Cross},
    methods: {
      gtmSend() {
        window.gtag('event', 'click', {
          'event_category': 'ch1_link_lenta_ru',
          'event_label': 'chapter_1'
        });
        window.ym(86974684, 'reachGoal', 'ch1_link_lenta_ru/click/chapter_1');
      }
    }
  }
</script>

<style scoped>

</style>
